module.exports = "/static/Images/images/profile.png";